import moment from "moment";

const initialState = {
  status: "invalid",
  filters: {
    histogram_country_codes: [],
    histogram_range_from: moment().subtract(1, 'month') ,
    histogram_range_to: moment(),
    histogram_delivery_methods: [],
    histogram_courier_names: [],
    histogram_interval: "day",
    histogram_date_option: "last_30_days"
  },
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PACKAGES_STATS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PACKAGES_STATS_UPDATING":
      return {
        ...state,
        status: "updating",
      };
    case "PACKAGES_STATS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "PACKAGES_STATS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    case "PACKAGES_STATS_SET_FILTER": {
      return {
        ...state,
        filters: { ...state.filters, ...action.filter },
      };
    }
    default:
      return state;
  }
};
